// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './ButtonGroup.css';

interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  fluid?: boolean;
}

export function ButtonGroup({
  children,
  fluid = false,
  className = '',
  ...rest
}: ButtonGroupProps) {
  const classes = [
    'fin-btn-group',
    fluid && 'fin-btn-group--fluid',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="group" {...rest}>
      {children}
    </div>
  );
}
